/* ===== CATI Pakistan — Hero Carousel ===== */
export function initCarousel() {
  const heroSection = document.querySelector('.hero');
  const carousel = document.querySelector('.hero__carousel');
  if (!heroSection || !carousel) return;

  // Clean up any existing timer on hero section
  if (heroSection._heroTimer) {
    clearInterval(heroSection._heroTimer);
    heroSection._heroTimer = null;
  }

  // Remove existing controls to ensure clean state on re-render
  heroSection.querySelectorAll('.hero-carousel__prev, .hero-carousel__next, .hero-carousel__indicators, .hero-carousel__counter')
    .forEach(el => el.remove());

  const slides = carousel.querySelectorAll('.carousel-slide');
  if (slides.length === 0) return;

  let current = 0;

  // Inject navigation controls if more than 1 slide
  if (slides.length > 1) {
    const prevBtn = document.createElement('button');
    prevBtn.className = 'hero-carousel__prev';
    prevBtn.setAttribute('aria-label', 'Previous Slide');
    prevBtn.setAttribute('type', 'button');
    prevBtn.innerHTML = '<i class="fa-solid fa-chevron-left"></i>';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'hero-carousel__next';
    nextBtn.setAttribute('aria-label', 'Next Slide');
    nextBtn.setAttribute('type', 'button');
    nextBtn.innerHTML = '<i class="fa-solid fa-chevron-right"></i>';

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'hero-carousel__indicators';

    const counterPill = document.createElement('div');
    counterPill.className = 'hero-carousel__counter';

    slides.forEach((_, idx) => {
      const dot = document.createElement('button');
      dot.className = `hero-carousel__dot${idx === 0 ? ' active' : ''}`;
      dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
      dot.setAttribute('type', 'button');
      dot.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showSlide(idx);
      };
      dotsWrap.appendChild(dot);
    });

    prevBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      prev();
    };

    nextBtn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      next();
    };

    heroSection.appendChild(prevBtn);
    heroSection.appendChild(nextBtn);
    heroSection.appendChild(dotsWrap);
    heroSection.appendChild(counterPill);
  }

  function updateControls(index) {
    const dots = heroSection.querySelectorAll('.hero-carousel__dot');
    dots.forEach((d, i) => d.classList.toggle('active', i === index));

    const counter = heroSection.querySelector('.hero-carousel__counter');
    if (counter) {
      counter.textContent = `${index + 1} / ${slides.length}`;
    }
  }

  function showSlide(index) {
    current = index;

    slides.forEach((slide, i) => {
      const isActive = (i === index);
      slide.classList.toggle('active', isActive);

      const video = slide.querySelector('video');
      const img = slide.querySelector('img');

      if (video) {
        if (isActive) {
          video.currentTime = 0;
          video.loop = true;
          video.onended = null;
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((err) => {
              console.warn('Hero video play fallback:', err);
            });
          }
        } else {
          video.pause();
          video.onended = null;
        }
      }

      if (img && isActive) {
        img.style.animation = 'none';
        void img.offsetWidth;
        img.style.animation = 'kenBurns 8s ease-in-out forwards';
      }
    });

    updateControls(index);
  }

  function next() {
    current = (current + 1) % slides.length;
    showSlide(current);
  }

  function prev() {
    current = (current - 1 + slides.length) % slides.length;
    showSlide(current);
  }

  // Initialize first slide manually without auto timer
  showSlide(0);
}

